import $ from 'jquery'
export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    //scripts for page Non Resident Latest News

    //show news by category
    function showNewsByCategory() {
      $('.news-item').show();
      if ($('.switchbtn').is('.switchbtn-active')){
        var category = $('.switchbtn-active').attr('data-category-switch');
        if(category !== 'all'){
          $('.news-item').hide();
          $('.news-item[data-category="' + category + '"]').show();
        }
      }
    }

    showNewsByCategory();

    $('.switchbtn').on('click', function () {
      if(!$(this).hasClass('switchbtn-active')){
        $('.switchbtn-active').removeClass('switchbtn-active');
        $(this).addClass('switchbtn-active');
        showNewsByCategory();
      }
    });
    //show news by date
    
    $('.archives-item').on('click', function () {
      showNewsByCategory();
      var currentDate = $(this).attr('data-date');
      $('.news-item:visible').each(function (index, item) {
        if($(item).attr('data-date') !== currentDate ) $(item).hide();
      })
    })

  }
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateLatestNews.js